/**
 * Theme type selector for storing and checking the theme
 */
export type Theme = 'light' | 'night';

export enum COMMONENUM {
    THEME = 'theme',
}
